import { SET_IS_BEING_DRAGGED } from './types';

export function setIsBeingDragged(data) {
	return {
		type: SET_IS_BEING_DRAGGED,
		payload: data
	};
}



// WEBPACK FOOTER //
// ./src/actions/isBeingDragged.js